import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { ECreditStatus } from '../../../../models/credit-status.enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'wealth-applet-wallet-credit-detail',
  standalone: true,
  imports: [CommonModule, PipesModule, NgxBadgeModule],
  templateUrl: './wallet-credit-detail.component.html',
  styleUrl: './wallet-credit-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletCreditDetailComponent {
  creditStatusEnum = input<ECreditStatus>();
  creditAmount = input<number>();
  creditStatus = ECreditStatus;
}
